/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Payload_ReadInputs */

const en_history_payload_read = /** @type {(inputs: History_Payload_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body of a message with TIL read`)
};

/**
* | output |
* | --- |
* | "Body of a message with TIL read" |
*
* @param {History_Payload_ReadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const history_payload_read = /** @type {((inputs?: History_Payload_ReadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Payload_ReadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_history_payload_read(inputs)
});